import { intersection } from 'lodash-es';

import {
  DispatchTripRead,
  PayerOrganizationRead,
} from 'src/common/external/bambi-api/bambiApi';

import { getPotentialMultiloadTripIds } from './getPotentialMultiloadTripIds';

const TIME_WINDOW_MINUTES_FOR_UNASSIGNED_TRIPS = 30;

export function getPotentialMultiloadCandidatesForUnassignedTrip(
  assignmentId: string,
  trip: DispatchTripRead,
  assignedTrips?: DispatchTripRead[],
  payers?: PayerOrganizationRead[]
) {
  const potentialMultiloadTripIds = getPotentialMultiloadTripIds(
    trip,
    [...(assignedTrips || [])],
    assignmentId,
    payers || [],
    undefined,
    TIME_WINDOW_MINUTES_FOR_UNASSIGNED_TRIPS
  );
  const tripsAlreadyAssignedToAssignment = assignedTrips?.filter(
    (t) => t.assignment_id === assignmentId
  );
  const hasPotentialMultiloadTripsAssigned =
    Array.isArray(tripsAlreadyAssignedToAssignment) &&
    intersection(
      tripsAlreadyAssignedToAssignment.map((t) => t.id),
      potentialMultiloadTripIds
    ).length > 0;

  return {
    potentialMultiloadTripIds,
    hasPotentialMultiloadTripsAssigned,
  };
}
